module.exports = __webpack_public_path__ + "static/media/llamar.a2e2b95c.png";